/**
 * UI·i18n 공통 언어 정책(단일 소스).
 * - 공식 5어: ko, en, ar, mn, id.
 * - 공식 언어가 아닌 브라우저/저장 언어는 en으로 fallback.
 * - `public/locales/{locale}/*.json` 는 앱 UI 번들 기준.
 */
export const OFFICIAL_LOCALE_CODES = ['ko', 'en', 'ar', 'mn', 'id'] as const;
export type OfficialLocaleCode = (typeof OFFICIAL_LOCALE_CODES)[number];

/** 백오피스 API 엔터티 `translations` 저장 슬롯. UI 공식 언어와 동일하게 5어 지원. */
export const API_TRANSLATION_LOCALE_CODES = ['ko', 'en', 'ar', 'id', 'mn'] as const;
export type ApiTranslationLocaleCode = (typeof API_TRANSLATION_LOCALE_CODES)[number];

/** 공식 5어에 포함되어 현재 별도 추가 UI 언어는 없다. */
export const ADDITIONAL_UI_LOCALE_CODES = [] as const;
export type AdditionalUiLocaleCode = (typeof ADDITIONAL_UI_LOCALE_CODES)[number];

/** i18next `supportedLngs`·`LanguageSwitcher`·API locale 해석에 사용 — 순서 유지. */
export const SUPPORTED_LOCALE_CODES = [...OFFICIAL_LOCALE_CODES] as const;
export type SupportedLocaleCode = (typeof SUPPORTED_LOCALE_CODES)[number];
